var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pool-action-btn",class:{
    active: _vm.checkedCount > 0 && !_vm.disabled,
    'is-disabled': _vm.disabled || !_vm.checkedCount,
  },on:{"click":_vm.batchRemove}},[_c('i',{staticClass:"el-icon-delete"}),_vm._v(" "+_vm._s(_vm.$l('btn_batch_remove') || '批量移除')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }